var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMultiLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5L6 1l4.5 8 5-8L20 9l4.5-8 5 8L34 1l5 8 4.5-8 5 8 5-8L58 8.5",
    stroke: "#387"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCA1OSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgOC41TDYgMUwxMC41IDlMMTUuNSAxTDIwIDlMMjQuNSAxTDI5LjUgOUwzNCAxTDM5IDlMNDMuNSAxTDQ4LjUgOUw1My41IDFMNTggOC41IiBzdHJva2U9IiMzMzg4NzciLz4KPC9zdmc+Cg==";
export { SvgMultiLines as ReactComponent };